const rankingData = [
  { rank: 1, title: '咒术回战', chapter: '第271话', heat: '本周更新', tag: '热血', icon: 'ri-fire-fill', color: 'text-primary-500' },
  { rank: 2, title: '海贼王', chapter: '第1134话', heat: '本周更新', tag: '冒险', icon: 'ri-ship-fill', color: 'text-primary-400' },
  { rank: 3, title: '间谍过家家', chapter: '第106话', heat: '昨日更新', tag: '喜剧', icon: 'ri-emotion-happy-fill', color: 'text-accent-500' },
  { rank: 4, title: '坂本日常', chapter: '第196话', heat: '昨日更新', tag: '动作', icon: 'ri-flashlight-fill', color: 'text-accent-400' },
  { rank: 5, title: '胆大党', chapter: '第183话', heat: '3天前', tag: '奇幻', icon: 'ri-ghost-fill', color: 'text-secondary-500' },
  { rank: 6, title: '怪兽8号', chapter: '第121话', heat: '本周更新', tag: '科幻', icon: 'ri-aliens-fill', color: 'text-secondary-400' },
  { rank: 7, title: '我推的孩子', chapter: '第168话', heat: '昨日更新', tag: '演艺', icon: 'ri-star-fill', color: 'text-accent-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            追更榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            最新漫画更新热度排行，追踪连载漫画的每一次更新动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="relative bg-background-50 rounded-xl p-4 flex flex-col items-center text-center hover:bg-primary-50/50 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-full bg-background-100 flex items-center justify-center mb-3 ${item.rank <= 3 ? 'ring-2 ring-offset-2 ' + (item.rank === 1 ? 'ring-primary-300' : item.rank === 2 ? 'ring-accent-300' : 'ring-secondary-300') : ''}`}>
                <span className={`font-heading text-lg font-black ${item.rank <= 3 ? 'text-primary-500' : 'text-foreground-400'}`}>
                  {item.rank}
                </span>
              </div>

              <div className="w-8 h-8 flex items-center justify-center mb-2">
                <i className={`${item.icon} text-xl ${item.color}`}></i>
              </div>

              <h3 className="font-heading text-sm font-bold text-foreground-800 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.chapter}</p>

              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[11px] font-medium">
                {item.heat}
              </span>
              <span className="text-[10px] text-foreground-400 mt-1">{item.tag}</span>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#index" className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer">
            查看更多漫画更新 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}